module.exports = __webpack_public_path__ + "img/secondpic1.3835944a.png";